import { createSelectionListViewContainer } from 'factories/SelectionListView'
import locationActions from 'actions/locations'
import Component from 'components/Orders/FormView/SelectBillTo'

export default createSelectionListViewContainer({
  extraDispatchToProps: (dispatch, props) => ({
    getItems: (params = {}) => dispatch(locationActions.getAddressList({ type: 'billTo', ...params })),
  }),
})(Component)
